"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PrivacyFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Link = _interopRequireDefault(require("@material-ui/core/Link"));
var _style = require("./style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PrivacyFooter = _ref => {
  let {
    color,
    itemCentralized,
    linkToHome,
    linkToTerms
  } = _ref;
  const classes = (0, _style.useStyles)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    className: itemCentralized ? classes.appBarCentralized : classes.appBar,
    color: color
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    className: classes.containerTitles
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2",
    className: itemCentralized ? classes.titleCentralized : classes.title
  }, "Copyrights 2021 | Saraiva Educa\xE7\xE3o"), /*#__PURE__*/_react.default.createElement("div", {
    className: itemCentralized && classes.divCentralizedLinks
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    href: linkToHome,
    className: itemCentralized ? classes.linkCentralized : classes.hiddenLink,
    variant: "body2"
  }, "Home"), /*#__PURE__*/_react.default.createElement(_Link.default, {
    target: "_blank",
    href: "https://www.canaldatransparencia.com.br/cogna/",
    className: itemCentralized ? classes.linkCentralized : classes.link,
    variant: "body2"
  }, "Politica de Privacidade"), /*#__PURE__*/_react.default.createElement(_Link.default, {
    target: "_blank",
    href: linkToTerms,
    className: itemCentralized ? classes.linkCentralized : classes.hiddenLink,
    variant: "body2"
  }, "Termo de Uso")))));
};
exports.PrivacyFooter = PrivacyFooter;
PrivacyFooter.propTypes = {
  /**
   * Altera a cor do Footer
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),
  /**
   * Se verdadeiro, centraliza os itens no Footer
   */
  itemCentralized: _propTypes.default.bool,
  /**
   * Se itemCentralized for verdadeiro, exibe o item de Home. Essa Prop é para colocar a string do caminho para a pagina inicial
   */

  linkToHome: _propTypes.default.string.isRequired,
  /**
   * Se itemCentralized for verdadeiro, exibe o item de Termo de Uso. Essa Prop é para colocar a string do caminho para a pagina de Termos de Uso
   */

  linkToTerms: _propTypes.default.string.isRequired
};
PrivacyFooter.defaultProps = {
  color: 'primary',
  itemCentralized: false
};
var _default = exports.default = PrivacyFooter;